export enum OnboardStep {
  Address = 'Address',
  MfaConfiguration = 'MfaConfiguration',
  MfaConfirm = 'MfaConfirm',
  Done = 'Done',
}
